import { useContext } from 'react';
import { CodeMasterContext } from '../context/CodeMasterContext';
import type { CodeMasterData } from '@/types/code-master';

export const useCodeMaster = (type: string) => {
  const codeMasters = useContext(CodeMasterContext);
  let res: CodeMasterData[] = [];
  if (codeMasters) {
    res = codeMasters?.filter((item) => item.type === type).map((item) => ({ key: item.value, value: item.content }));
  }

  return res;
};
